import { Component, Inject } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { IBillingShippingModel } from "../../../../interfaces/LicenseModel";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";
import { AppLoaderService } from "../../../../../services/app-loader/app-loader.service";
import * as constants from "../../constants";


@Component({
  selector: "generate-syncit-license",
  styles: [require('./generate-syncit-license.component.css')],
  template: require('./generate-syncit-license.component.html'),
})
export class GenerateSyncITLicenseComponent {
  dialogTitle = "";
  errorMessage = "";

  syncITLicenseForm: FormGroup;

  billingShippingDetail: IBillingShippingModel = {
    ODataEtag: "",
    Number: "",
    publicId: "",
    CustomerNo: "",
    publicSalesPersoncode: "",
    BillToName: "",
    BillToAddress1: "",
    BillToAddress2: "",
    BillToCity: "",
    BillToState: "",
    BillToZipcode: "",
    BillToCountryCode: "",
    ShipToCode: "",
    ShipToName: "",
    ShipToAddress1: "",
    ShipToAddress2: "",
    ShipToCity: "",
    ShipToState: "",
    ShipToZipcode: "",
    ShipToCountryCode: "",
    CustomerTelephone: "",
    CustomerEmailAddress: "",
    CustomerFaxno: "",
    ShippingTelephoneno: "",
    ShippingFaxno: "",
    ShippingEmailAddress: "",
    Rep1: "",
    Rep2: "",
    Sales1: "",
    Sales2: "",
  };

  isBillingShippingDetailFetched = false;

  submitted: boolean = false;
  customerId = 0;
  shippingAddressId = 0;
  shouldFetchSalesOrderNo = false;
  SyncItLicenseList: any;

  MAX_TRIAL_INSTRUMENTS = constants.MAX_TRIAL_INSTRUMENTS;
  error = "";
  isLoading = false;
  syncItproductList: any;
  prevSalesOrderNo = "";
  constructor(
    private dialogRef: MdDialogRef<GenerateSyncITLicenseComponent>,
    private formBuilder: FormBuilder,
    private licenseService: LicenseService,
    private appLoader: AppLoaderService,
    private snackBar: MdSnackBar,
    private adalService: AdalService,
    private router: Router,
    @Inject(MD_DIALOG_DATA) public dialogData: any,
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.buildForm();

    this.syncItproductList = this.dialogData.syncITproducts;
    this.SyncItLicenseList = this.dialogData.SyncITLicenseData;
    this.dialogTitle = this.dialogData.dialogTitle;

    const productFormGroups = this.syncItproductList.map((product) =>
      this.formBuilder.group({
        ProductId: [product.ProductEnum],
        ProductName: [product.SyncITProductName],
        NoOfLicense: [0, Validators.min(0)],
      }),
    );
    const licenseTypeControl = this.syncITLicenseForm.get("LicenseType");
    const productsArray = this.syncITLicenseForm.get("Products") as FormArray;

    // 1️⃣ Populate initial NoOfLicense based on LicenseType
    setTimeout(() => {
      if (licenseTypeControl.value === "1") {
        productsArray.controls.forEach((c) => c.get("NoOfLicense").setValue(5));
      } else {
        productsArray.controls.forEach((c) => c.get("NoOfLicense").setValue(0));
      }
    }, 0);

    // Listen to LicenseType changes
    this.syncITLicenseForm.get("LicenseType").valueChanges.subscribe((val) => {
      const control = this.syncITLicenseForm.get("NoOfMonths");
      const productsArray = this.syncITLicenseForm.get("Products") as FormArray;

      if (val === "1") {
        // Trial
        control.setValue(1);
        control.disable();

        // Set NoOfLicense = 5 for each product
        productsArray.controls.forEach((c) => c.get("NoOfLicense").setValue(5));
      } else {
        // Purchase
        control.enable();

        // Reset NoOfLicense = 0 for each product
        productsArray.controls.forEach((c) => c.get("NoOfLicense").setValue(0));
      }
    });
    const productsFormArray: FormArray = this.syncITLicenseForm.get(
      "Products",
    ) as FormArray;

    productFormGroups.forEach((fg) => productsFormArray.push(fg));
  }

  buildForm() {
    this.syncITLicenseForm = this.formBuilder.group({
      SalesOrderNo: ["", [Validators.required]],
      PurchaseDate: ["", Validators.required],
      clientName: ["", Validators.required],
      NoOfMonths: [
        { value: 1, disabled: true },
        [Validators.required, Validators.min(1), Validators.max(120)],
      ],
      LicenseType: ["1", Validators.required],
      clientAdminEmail: ["", [Validators.required, Validators.email]],
      Products: this.formBuilder.array([]),
    });
  }

  blurSalesOrderEvent() {
    if (
      this.prevSalesOrderNo.trim().toUpperCase() ==
      this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase()
    ) {
      return;
    }
    this.prevSalesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
    setTimeout(() => {
      this.shouldFetchSalesOrderNo = true;
      this.isBillingShippingDetailFetched = false;
    }, 150);
  }

  get productsFormArray(): FormArray {
    return this.syncITLicenseForm.get("Products") as FormArray;
  }

  checkSalesOrderNo() {
    if (this.dialogData.SyncItLicenseList) {
      let exist = this.dialogData.SyncItLicenseList.some((element) => {
        if (element.SalesOrderNo != null) {
          return (
            this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase() ==
            element.SalesOrderNo.trim().toUpperCase()
          );
        } else {
          return false;
        }
      });

      if (exist) {
        Swal.fire({
          title: "This sales order no already exists",
          text: "Are you sure you want to use this Sales Order No?",
          showCancelButton: true,
          showCloseButton: true,
          showConfirmButton: true,
          confirmButtonText: "Yes",
          confirmButtonColor: "#FFCA28",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
          } else {
            this.shouldFetchSalesOrderNo = false;
            this.syncITLicenseForm.patchValue({
              SalesOrderNo: "",
            });
          }
        });
      } else {
        this.shouldFetchSalesOrderNo = true;
        this.isBillingShippingDetailFetched = false;
        this.getBillingShippingDetail();
      }
    } else {
      this.shouldFetchSalesOrderNo = true;
      this.isBillingShippingDetailFetched = false;
      this.getBillingShippingDetail();
    }
  }

  getBillingShippingDetail() {
    let salesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
    if (salesOrderNo != "") {
      if (this.shouldFetchSalesOrderNo) {
        this.appLoader.open();
        this.licenseService
          .getBillingShippingDetail(salesOrderNo)
          .subscribe((data) => {
            if (!data.IsError && data.DataObject != null) {
              this.syncITLicenseForm.patchValue({
                clientName: data.DataObject.BillToName,
              });
              this.billingShippingDetail = data.DataObject;
              this.isBillingShippingDetailFetched = true;
              this.error = "";
            } else {
              this.isBillingShippingDetailFetched = false;
              this.error = data.Error;
            }
            this.appLoader.close();
          });
      } else {
        this.error = "Please select other sales order number.";
      }
    } else {
      this.error = "Sales Order No is required";
      this.isBillingShippingDetailFetched = false;
    }
  }
  onSave() {
    const licenseTypeControl = this.syncITLicenseForm.get("LicenseType");
    const formValue = this.syncITLicenseForm.getRawValue();

    const totalLicenses = formValue.Products.reduce(
      (sum: number, p: any) => sum + (Number(p.NoOfLicense) || 0),
      0,
    );

    if (totalLicenses === 0) {
      Swal.fire({
        icon: "warning",
        title: "No License Selected",
        text: "Please purchase at least one instrument license before saving.",
        confirmButtonText: "Ok",
        confirmButtonColor: "#FFCA28",
      });
      return; // Stop saving
    }

    if (licenseTypeControl && licenseTypeControl.value === "1") {
      const totalLicenses = formValue.Products.reduce(
        (sum: number, p: any) => sum + (Number(p.NoOfLicense) || 0),
        0,
      );
      if (totalLicenses > this.MAX_TRIAL_INSTRUMENTS) {
        Swal.fire({
          icon: "warning",
          title: "Limit Exceeded",
          text: `Trial license allows maximum ${this.MAX_TRIAL_INSTRUMENTS} instruments.`,
          confirmButtonText: "Ok",
          confirmButtonColor: "#FFCA28",
        });
        return; // stop save
      }
    }

    if (this.syncITLicenseForm.valid) {
      this.appLoader.open();
      const formValue = this.syncITLicenseForm.getRawValue();
      this.licenseService
        .addBillingShippingDetailsSyncIT(this.billingShippingDetail)
        .subscribe((data) => {
          if (!data.IsError && data.DataObject != null) {
            const payload = {
              CustomerId: data.DataObject.CustomerId,
              ShippingAddressId: data.DataObject.ShippingAddressId,
              NoOfMonths: formValue.NoOfMonths,
              LicenseType: formValue.LicenseType,
              SalesOrderNo: formValue.SalesOrderNo,
              PurchaseDate: formValue.PurchaseDate,
              clientAdminEmail: formValue.clientAdminEmail,
              clientName:formValue.clientName,
              deviceDetails: formValue.Products.filter(
                (p) => p.NoOfLicense > 0,
              ).map((p) => ({
                SyncItProductId: p.ProductId,
                NoOfProductLicense: p.NoOfLicense,
              })),
            };

            this.licenseService.GenerateSyncITLicense(payload).subscribe({
              next: (res) => {
                if (!res.IsError) {
                  this.dialogRef.close(res.DataObject);
                  this.snackBar.open("License saved successfully", "", {
                    duration: 3000,
                  });
                  this.errorMessage = "";
                  this.appLoader.close();
                } else {
                  this.appLoader.close();
                  this.errorMessage = res.Error;
                  Swal.fire({
                    icon: "warning",
                    title: "Error",
                    text: res.Error,
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFCA28",
                  });
                }
              },
              error: (err) => {
                this.appLoader.close();
                this.errorMessage = "Something went wrong.";
              },
            });
          }
        });
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  get isSaveDisabled(): boolean {
    if (!this.syncITLicenseForm) return true;

    // If form invalid → Disable Save
    if (!this.syncITLicenseForm.valid) return true;

    if (!this.isBillingShippingDetailFetched) return true;

    const licenseTypeControl = this.syncITLicenseForm.get("LicenseType");

    // if (licenseTypeControl && licenseTypeControl.value === "1") {
    //   const totalLicenses = this.productsFormArray.controls.reduce(
    //     (sum, ctrl) => {
    //       const val = ctrl.get("NoOfLicense");
    //       return sum + (val ? Number(val.value) : 0);
    //     },
    //     0
    //   );

    //   if (totalLicenses > 20) {
    //     return true; // Disable Save
    //   }
    // }

    this.errorMessage = "";
    return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/popup/generate-syncit-license/generate-syncit-license.component.ts